<script lang="ts">
    // Stores
    import { getI18n } from '~/stores/i18n';
    import {
        editPlaylistData,
        showEditPlaylistModal,
    } from '~/stores/playlists';

    // Local Component
    import PlaylistModal from '~/components/playlists/PlaylistModal.svelte';

    // App Utils
    import { getJet } from '~/jet';
    import { makeModifyPlaylistAction } from '@jet-app/music-classical/action-model/ModifyPlaylistAction';

    const i18n = getI18n();
    const jet = getJet();
    $: title = $editPlaylistData?.title;
    $: description = $editPlaylistData?.description;

    async function editPlaylist({ detail: { title, description } }) {
        // Todo: Add Metrics once Classical Metrics spec is available
        // rdar://140809394 ([Classical on Web] Add Metrics for Create/Edit Playlist once the Instrumentation Spec is ready)
        // jet.recordCustomMetricsEvent(getPlaylistModalMetricsEvent('create'));
        await jet.perform(
            makeModifyPlaylistAction('editPlaylist', {
                name: title,
                description,
                playlistId: $editPlaylistData?.playlistId,
                librarySongs: $editPlaylistData?.librarySongs,
                offset: $editPlaylistData?.offset,
            }),
        );
        $showEditPlaylistModal = false;
        $editPlaylistData = null;
    }

    async function close() {
        $showEditPlaylistModal = false;
        $editPlaylistData = null;
        // jet.recordCustomMetricsEvent(getPlaylistModalMetricsEvent('cancel'));
    }
</script>

<!-- 
headerText={$i18n.t(
            'ASE.Web.MusicClassical.Library.PlaylistEdition.Header',
        )}
        submitText={$i18n.t(
            'ASE.Web.MusicClassical.Library.PlaylistEdition.Submit',
        )}
-->
{#if $editPlaylistData}
    <PlaylistModal
        headerText={'Edit Playlist'}
        submitText={'Done'}
        {title}
        {description}
        isOpen={true}
        on:submit={editPlaylist}
        on:close={close}
    />
{/if}
